import type { psAxiosInstance } from '@patsnap/common-ps-http';
import type { ListItem } from '@/type/list';
import { Site, SLD } from '@patsnap-utils/biz';
import { getFullListType1 } from '@cores/config/data_config/fulllist_type_1';
import getPsHttp from '@/config/http';
import type { AccountInfo } from '@patsnap-utils/biz/src/apis';

const ACCOUNT_URI = new Site({ sld: SLD.ACCOUNT_SERVICE }).href;
const LAB_SERVICE = process.env.VUE_APP_LAB_SERVICE_URI;

export const GetHost = (url: string) => {
    const _url = url.match(/https?:\/\/([^/]+)/i);
    let domain = '';
    if (_url && _url[1]) {
        domain = _url[1];
    }
    return domain;
};

const GetClientTime = () => {
    try {
        const _domain = GetHost(document.getElementsByTagName('script')[0].baseURI);
        const token = 'qwieu05erprtasldd:f61jh/gzbcx.m-vlmoii2utyrepwlaskdj7f3hgbvnc4mxc8xxzqw9e';
        const indexLength: number[] = [];
        const _arr = _domain.split('');
        const result = _arr.map((item: string) => {
            const _index = token.indexOf(item);
            const _indexLength = `${_index}`.length;
            indexLength.push(_indexLength);
            return _index >= 0 ? _index : item;
        });
        return `${result.join('')}&&${indexLength.join('')}`;
    } catch (e) {
        console.log(e);
        return false;
    }
};

export class ProductsService {
    private readonly _products: ListItem[] = getFullListType1();
    public refreshKey = '1';

    private _dictProducts = this._products.reduce((obj: { [name: string]: ListItem }, product) => {
        obj[product.key as string] = product;
        return obj;
    }, {})

    beforeRenderProducts: (products: ListItem[]) => ListItem[] = _ => _

    private calcProducts: (products: ListItem[]) => ListItem[] = _ => _
    syncing: boolean
    private _info: AccountInfo | undefined;

    static get psHttp(): psAxiosInstance['psHttp'] {
        return getPsHttp();
    }

    constructor() {
        this.syncing = false;
    }

    get products() {
        const items = this.calcProducts(this._products);
        return this.beforeRenderProducts(items);
    }

    get whiteLabel() {
        return this._info?.company_label_switcher;
    }

    get homeBtnVisible() {
        return (this._info?.granted_products || []).map(({ name }) => name).includes('home');
    }

    /**
     * INNO_CLOUD通过微前端集成了九宫格，他们使用customDataGetter对改方法进行了覆写，如果改方法有变动，需要通知INNO_CLOUD进行同步变更
     **/
    public dataGetter(): Promise<AccountInfo> {
        const url = `${ACCOUNT_URI}/user-service/account-info/extra-data`;
        return ProductsService.psHttp<{ data: any }>({
            url,
            headers: {
                'x-api-version': '2.0',
            },
            uuid: url,
            cache: true,
        })
            .then(res => res.data.data);
    }

    async sync(): Promise<void> {
        this._info = await this.dataGetter();
        const info = this._info as AccountInfo || {};

        this.calcProducts = (_products: ListItem[]) => {
            const products = [
                ...(info.granted_products || []),
                ...(this.whiteLabel ? [] : (info.non_granted_products || []))
            ];

            let results: any[] = [];
            const tail: any[] = [];

            products.forEach(product => {
                if (this._dictProducts[product.name]) {
                    if (product.name === 'lab') {
                        tail.push({ name: 'lab' });
                    } else {
                        results.push(product);
                    }
                }
            });

            results = [...results, ...tail].map(({ name, homepage_url }) => {
                const { key, icon, href, ...attrs } = this._dictProducts[name];
                const computed_href = href || homepage_url;
                return {
                    key,
                    icon,
                    ...attrs,
                    href: key === SLD.INNOSNAP ? homepage_url : computed_href,
                };
            });
            return results;
        };
    }

    async getAccoutTime(): Promise<void> {
        const Timer = GetClientTime();
        const data = {
            app_id: Timer,
        };
        const url = `${LAB_SERVICE}/lab-service/apps/app/info`;
        this._info = await ProductsService.psHttp<{ data: any }>({
            url,
            method: 'POST',
            data,
        })
            .then(res => res.data.data)
            .catch(() => {
                return {};
            });
    }
}
